import { canUseExperimentationOnClient } from '../consent/waitingForConsent'
import { SET_OPTIMIZELY_EXPERIMENTS } from './actionConstants'
import type { AppAction } from './types/ActionTypes'
import { trackEvent } from 'analytics/analytics'
import type { ExperimentId } from 'constants/experiments'
import { isExperimentPreview } from 'lib/experiments/preview'
import { getExperimentActivationEvent } from 'lib/experiments/experimentActivation'
import { isAllowedToTriggerExperiment, setTriggeredCookie } from 'lib/optimizely/optimizelyUtils'

export function setOptimizelyExperiment(experimentId: string, experiment: App.OptimizelyExperimentDetails, force?: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (isExperimentPreview(state)) return
    if (!force && state.optimizely.optimizelyExperiments[experimentId]?.triggered) {
      return
    }

    dispatch({
      type: SET_OPTIMIZELY_EXPERIMENTS,
      experiments: {
        [experimentId]: {
          ...experiment,
          triggered: !force ? true : experiment.triggered,
        },
      },
    })
  }
}

export function activateOptimizelyExperiment(experimentId: ExperimentId): AppAction {
  return (dispatch, getState) => {
    if (!canUseExperimentationOnClient()) return
    const state = getState()
    if (isExperimentPreview(state) || !isAllowedToTriggerExperiment(true, state.utm.content, experimentId)) return

    const experiment = state.optimizely.optimizelyExperiments[experimentId]
    if (!experiment || experiment.triggered) return

    const activationEvent = getExperimentActivationEvent(experimentId, experiment)
    if (!activationEvent) return

    trackEvent(activationEvent)
    dispatch(setOptimizelyExperiment(experimentId, experiment))
    setTriggeredCookie(experimentId, 'optimizely')
  }
}
